import { Stack, Text } from '@shopify/polaris';
import { creating_action_image } from "../../../../../assets/index.js";

const CreatingActionLoadingComponent = () => {
    return (
        <Stack vertical alignment="center" spacing="loose">
            <img
                src={creating_action_image}
                alt="Adding products in your action"
                width="249px"
                height="249px"
                style={{
                    objectFit: "cover",
                    objectPosition: "center"
                }}
            />
            <Text as="h2" variant="headingLg" fontWeight="bold">
                Creating your action...
            </Text>
            <Text as="p" variant="bodyMd">
                You're almost done! Please wait while finish everything up for the action. This will take a while depending on the number of products in your action.
            </Text>
        </Stack>
    );
};

export default CreatingActionLoadingComponent;